const menu = [
  {
    name: "首页",
    path: "/"
  },
  {
    name: "计划",
    nameSpan: "image/index/headerMenuX.png",
    path: "/xplan"
  },
  {
    name: "解决方案",
    path: "/solution",
    type:'3',
    children:[{
      name:'无线网络',
      icon:'image/solution/wifi-icon.png',
      pathList:[{
        name:'高校',
        path:''
      },{
        name:'中职',
        path:''
      },{
        name:'工地',
        path:''
      },{
        name:'工厂',
        path:''
      }]
    },{
      name:'智慧校园',
      icon:'image/solution/school_icon.png',
      pathList:[{
        name:'校园一卡通',
        path:''
      }]
    },{
      name:'智慧园区',
      icon:'image/solution/factory_icon.png',
      pathList:[{
        name:'智慧工业园区',
        path:''
      }]
    }]
  },
  {
    name: "产品中心",
    type:"2",
    path: "/product",
    children: [
      {
        name: "无线网络产品",
        list: [
          {
            name: "智能联接",
            pathList: [
              {
                name: "网关",
                path: ""
              },
              {
                name: "交换机",
                path: ""
              },
              {
                name: "AP",
                path: ""
              },
              {
                name: "OLT",
                path: ""
              },
              {
                name: "ODN",
                path: ""
              }
              ,
              {
                name: "MDU",
                path: ""
              }
              ,
              {
                name: "光AP",
                path: ""
              }
            ]
          },
          {
            name: "运营管理",
            pathList: [
              {
                name: "认证计费系统",
                path: ""
              },
              {
                name: "网管系统",
                path: ""
              }
            ]
          },
          {
            name: "高阶辅助",
            pathList: [
              {
                name: "运营中台",
                path: ""
              },
              {
                name: "运维工单",
                path: ""
              },
              {
                name: "客服系统",
                path: ""
              },
              {
                name: "审计系统",
                path: ""
              },
              {
                name: "进销存系统",
                path: ""
              },
              {
                name: "CRM系统",
                path: ""
              },
              {
                name: "上网管控",
                path: ""
              }
            ]
          }
        ]
      },
      {
        name: "智慧校园产品",
        list: [
          {
            name: "智能联接",
            pathList: [
              {
                name: "宿舍水电控设备",
                path: ""
              },
              {
                name: "智能饮用热水设备",
                path: ""
              },
              {
                name: "通道闸机",
                path: ""
              },
              {
                name: "人脸门禁机",
                path: ""
              },
              {
                name: "三刷智能消费机",
                path: ""
              }
              ,
              {
                name: "智能校园视频话机",
                path: ""
              }
              ,
              {
                name: "智能电子学生证",
                path: ""
              }
              ,
              {
                name: "智能电子班牌",
                path: ""
              }
            ]
          },
          {
            name: "运营管理",
            pathList: [
              {
                name: "校园安全系统",
                path: ""
              },
              {
                name: "校园生活系统",
                path: ""
              },
              {
                name: "教务总务系统",
                path: ""
              }
            ]
          }
        ]
      },
      // {
      //   name: "智慧校园产品：",
      // }
    ]
  },
  {
    name: "合作案例",
    path: "/partner",
    type: "1",
    children: [
      {
        name: "无线网络",
        path: "/partner?type=1"
      },
      {
        name: "智慧校园",
        // path: "/partner?type=2"
      },
      {
        name: "智慧园区",
        // path: "/partner?type=3"
      }
    ]
  },
  {
    name: "新闻动态",
    path: "/news",
    type: "1",
    children: [
      {
        name: "展会风采",
        path: "/news?type=1"
      },
      {
        name: "项目拓展",
        path: "/news?type=2"
      },
      {
        name: "Lemon动态",
        path: "/news?type=3"
      },
      {
        name: "其他",
        path: "/news?type=4"
      }
    ]
  },
  {
    name: "关于我们",
    type: "1",
    path: "/about",
    children: [
      {
        name: "公司介绍",
        path: "/about"
      },
      {
        name: "联系我们",
        path: "/contact"
      },
      {
        name: "人才招聘",
        path: "/talent"
      }
    ]
  },


];

export default menu;



// WEBPACK FOOTER //
// ./src/components/header/menu.js